<template>
    <div class="field-radiobuttons field-wrap">
        <ul class="field-radiobuttons__list">
            <li
                v-for="(options__value, options__key) in options"
                v-bind:key="id + '_' + options__key"
                class="field-radiobuttons__list-item"
            >
                <input
                    type="radio"
                    :id="id + '_' + options__key"
                    v-model="simpleFieldModel"
                    :value="Array.isArray(options) ? options__value : options__key"
                    class="field-radiobuttons__input"
                />
                <label :for="id + '_' + options__key" class="field-radiobuttons__label"
                    ><span class="field-radiobuttons__pseudo-radio"></span
                    >{{ options__value }}</label
                >
            </li>
        </ul>
    </div>
</template>

<script>
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {},
    methods: {},
    computed: {},
    mixins: [SimpleFieldMixin],
    props: {
        options: [Object, Array]
    }
};
</script>
